import { Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { EditorConfig, ST_BUTTONS } from 'ngx-simple-text-editor';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { PaginationService } from 'src/app/PaginationService';
import { AppService } from 'src/app/app.service';
import { messageService } from 'src/app/message.service';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { DomSanitizer } from '@angular/platform-browser';
import { DynamicAuditTrailComponent } from 'src/app/support/dynamic-audit-trail/dynamic-audit-trail.component';
import { ExcelPdfComponent } from 'src/app/support/excel-pdf/excel-pdf.component';
import { DatePipe } from '@angular/common';
import { GridReorderComponent } from '../../grid-reorder/grid-reorder.component';

@Component({
  selector: 'app-document-header-template',
  templateUrl: './document-header-template.component.html',
  styleUrls: ['./document-header-template.component.scss']
})
export class DocumentHeaderTemplateComponent implements OnInit {

  isProcessing = true;
  _temp: any = {};
  reportHeaderTemplateList: any = [];
  reportHeaderTemplateData: any = {};
  previewData: any;
  constructor(public dialog: MatDialog, private readonly appService: AppService, public router: Router, private readonly snackBar: MatSnackBar, private readonly datePipe: DatePipe,
    public paginationService: PaginationService, public message: messageService, private readonly elem: ElementRef, public sanitizer: DomSanitizer) { }

  visibleDataGrid: boolean = false;
  itemsPerPage = 5; // Number of items to display per page
  currentPage = 1; // Current page number
  totalPages = 0; // Total number of pages
  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;
  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  showingRowsText = "Showing rows";
  private readonly users: any[];
  pager: any = {};
  pagedItems: any[];
  auditTrail: any = {};
  visibleAuditTrail: boolean = false;
  error = '';
  @ViewChild(ExcelPdfComponent) excelPdfComponent!: ExcelPdfComponent;
  excelPdf: any = {};
  reportObj: any = {};
  setPage(page: number, targetPage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }

    this.pager = this.paginationService.getPager(this.reportHeaderTemplateList.length, page, this.perPage, targetPage);
    this.pagedItems = this.reportHeaderTemplateList.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }

  setPagedOrSearch(page: number, targetPage: number) {
    if (Number.isNaN(page)) {
      page = 1;
    }
    if (this.reportHeaderTemplateList.length > 0) {
      this.pager = this.paginationService.getPager(this.reportHeaderTemplateList.length, page, this.perPage, targetPage);
      this.pagedItems = this.reportHeaderTemplateList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = [];
    }
  }

  columnLists: any = {};
  makeStickyColumns: any;
  dataTypeList: any = [];
  getCall() {
    this.isProcessing = true;
    this.reportHeaderTemplateList = [];
    const data = {

      gridName: "DOCUMENT_REPORT_HEADER_TEMPLATE"
    }

    setTimeout(() => {
      this.isProcessing = false;
    }, 3000);
    this.appService.getDynamicGridHeaders(data).subscribe({
      next: (response: any) => {
        response.orderByClause ??= "";

        this.makeStickyColumns = response.fixedFieldCnt;

        const data1: any = {

          gridName: "DMS_DOCUMENT_REPORT_HEADER_TEMPLATE_VW",
          tableOrViewName: response.tableOrViewName ?? "",
          columnsList: response.columnsList ?? "",
          fieldLabelsList: response.fieldLabelsList ?? "",
          invisibleColumn: response.invisibleColumn ?? "",
          orderByClause: response.orderByClause ?? "",
          fieldSizeList: response.fieldSizeList ?? "",
          columnsListarray: [],
          fieldColumnarray: [],
          invisibleColumnarray: [],
          fieldSizeListArray: [],
          manualEntryDataFields: response.manualEntryDataFields,
          clobColumnlist: response.closblist || "",
          blobColumnlist: response.bloblist || ""
        }
        this.reportObj = { ...data1, ...data };
        this.appService.getDynamicGridData(data1).subscribe({
          next: (response1: any) => {
            this.reportHeaderTemplateList = response1;
            this.visibleAuditTrail = false;
            data1.columnsListarray = data1.columnsList.split(",");
            data1.fieldColumnarray = data1.fieldLabelsList.split(",");
            data1.invisibleColumnarray = data1.invisibleColumn.split(",");
            data1.fieldSizeListArray = data1.fieldSizeList.split(",");
            let rendereddata: any;

            this.columnLists.columnsListarray = data1.columnsListarray;
            this.columnLists.fieldLabelsList = data1.fieldLabelsList;
            this.columnLists.fieldColumnarray = [];
            for (let p = 0; p < data1.fieldColumnarray.length; p++) {
              this.columnLists.fieldColumnarray.push({
                "fieldColumnarray": data1.fieldColumnarray[p],
                "width": data1.fieldSizeListArray[p] + 'px'
              })
            }
            this.columnLists.invisibleColumnarray = data1.invisibleColumnarray;
            this.columnLists.fieldSizeListArray = [];
            for (const size of data1.fieldSizeListArray) {
              this.columnLists.fieldSizeListArray.push(size + 'px');
            }

            let y = 0;
            while (y < this.columnLists.columnsListarray.length) {
              const currentColumn = this.columnLists.columnsListarray[y];
              const isInvisible = this.columnLists.invisibleColumnarray.includes(currentColumn);
              if (isInvisible) {
                this.columnLists.columnsListarray.splice(y, 1);
                this.columnLists.fieldColumnarray.splice(y, 1);
                this.columnLists.fieldSizeListArray.splice(y, 1);
              } else {
                y++;
              }
            }

            let tableData = {
              tablename: data1.tableOrViewName
            };
            this.columnLists.columnsListarray1 = [];
            this.appService.tableFieldsDataType(tableData).subscribe({
              next: (response2: any) => {
                this.dataTypeList = response2;
                for (let m = 0; m < this.columnLists.columnsListarray.length; m++) {
                  this.columnLists.columnsListarray1.push({});
                  this.columnLists.columnsListarray1[m].columnsListarray = this.columnLists.columnsListarray[m];
                  this.columnLists.columnsListarray1[m].dataType = "textbox";
                  this.columnLists.columnsListarray1[m].width = this.columnLists.fieldSizeListArray;
                  for (const dataType of this.dataTypeList) {
                    if (dataType.columnName == this.columnLists.columnsListarray[m]) {
                      this.columnLists.columnsListarray1[m].dataType = dataType.fieldType;
                    }
                  }
                }
                for (const reportHeader of this.reportHeaderTemplateList) {

                  for (const dataType of this.dataTypeList) {
                    if (dataType.fieldType == 'CHECKBOX') {
                      reportHeader[dataType.columnName] = reportHeader[dataType.columnName] === 'Y';
                    }
                  }

                }
                this.calculateTotalPages = this.collectionSize / this.perPage;
                this.pager.totalPages = undefined;
                this.setPage(1, 0);
              }, error: (error) => {
                this.isProcessing = false;
                throw error;
              }
            });
            this.message.gridList = this.reportHeaderTemplateList;
            this.collectionSize = this.reportHeaderTemplateList.length;
            this.totalPages = Math.ceil(this.reportHeaderTemplateList.length / this.itemsPerPage);
            this.dynamicLabelCall();
          }, error: (error) => {
            this.isProcessing = false
            throw error;
          }
        });
        this.isProcessing = false;
      }, error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });

  }

  focusEmpty() {
    console.log();
  }
  ngOnInit() {
    this.getCall();
  }

  counts: any;
  cssfunction(ix: number) {
    let elements1 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-col1');
    let index1 = 1;
    let headerWidth = 0;
    elements1.forEach((header: any, key: any) => {
      for (let i = 1; i <= this.makeStickyColumns; i++) {
        if (index1 == i) {
          header.style.position = 'sticky';
          header.style.background = 'white';
          if (index1 > 1) {
            headerWidth += 200;
            header.style.left = headerWidth + 'px';
          } else {
            headerWidth = 60;
            header.style.left = headerWidth + 'px';
          }
        }
      }

      index1++;
    })


    let elements2 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-row1');
    let index2 = 1;
    let lengthOfColumns = this.columnLists.columnsListarray1.length;
    let colWidth = 0;
    let p = 1;
    elements2.forEach((column: any, key: any) => {
      for (let j = 1; j <= this.makeStickyColumns; j++) {
        if (index2 == j) {
          column.style.position = 'sticky';
          p = p + 1;
          column.style.background = 'white';
          if (index2 > 1) {
            colWidth += 200;
            column.style.left = colWidth + 'px';
          } else {
            colWidth = 60;
            column.style.left = colWidth + 'px';
          }
          column.addEventListener('click', this.onClick.bind(this));
        }
      }
      if (index2 == (lengthOfColumns - 1)) {
        index2 = 0;
      } else {
        index2++;
      }

    })
  }

  onClick(event: any) {
  }

  dynamicLabel: any = null;
  label: any = [];
  dynamicLabelCall() {
    this.isProcessing = true;
    const data = {
      tableName: this.reportObj.tableOrViewName,
      moduleName: null,
      gridName: this.reportObj.gridName,
      groupId: 0,
    };
    this.appService.getreorderGirdColumnList(data).subscribe({
      next: (data: any) => {
        this.label = data;
        this.dynamicLabel = this.label.reduce((acc: any, user: any) => {
          acc[`${user.columnName}`] = user.changedFieldName;
          return acc;
        }, {});
        this.isProcessing = false;
      }, error: (error: any) => {
        this.isProcessing = false;
      }
    });
  }

  applyFilter3(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();

    if (filter === '') {
      this.pagedItems = this.reportHeaderTemplateList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.reportHeaderTemplateList.filter((item: any) =>
        item[column]?.toLowerCase().includes(filter)

      );
    }
  }

  searchValue: any;
  searchValue2: any;
  applyFilter2(event: Event) {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pager = this.paginationService.getPager(this.reportHeaderTemplateList.length, 1, this.perPage, 0);
      this.pagedItems = this.reportHeaderTemplateList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {

      if (this.reportHeaderTemplateList == undefined) {
        return this.reportHeaderTemplateList;
      }
      if (!this.reportHeaderTemplateList.length) {
        return this.reportHeaderTemplateList;
      }
      if (filter) {
        this.reportHeaderTemplateList = this.reportHeaderTemplateList.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase().includes(filter);
        });

      } else {
        this.reportHeaderTemplateList = this.reportHeaderTemplateList.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase();
        });
      }
      this.setPagedOrSearch(1, 0);
    }
  }

  sortedColumn: string = '';
  sortDirection: string = 'asc';
  sortColumn(column: string, list: any) {
    if (column === this.sortedColumn) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortedColumn = column;
      this.sortDirection = 'asc';
    }
    list.showsort = this.sortDirection;

    this.reportHeaderTemplateList.sort((a: { [x: string]: any; }, b: { [x: string]: any; }) => {
      const key = column;
      const valueA = a[key];
      const valueB = b[key];

      if (valueA! < valueB!) {
        return this.sortDirection === 'asc' ? -1 : 1;
      } else if (valueA! > valueB!) {
        return this.sortDirection === 'asc' ? 1 : -1;
      } else {
        return 0;
      }
    });
    this.setPage(1, 0);
  }

  parentCheckBox: boolean = false;
  childCheckBox: boolean = false;

  dataGridParentCheckBoxChecked(e: any) {
    if (e.target.checked) {
      this.childCheckBox = true;
      for (const element of this.reportHeaderTemplateList) {
        element.childCheckBox = true;
      }
    } else {
      this.childCheckBox = false;
      for (const element of this.reportHeaderTemplateList) {
        element.childCheckBox = false;
      }
    }
  }

  previousSelectedValue: any;
  dataGridChildCheckBoxChecked(e: any, list: any, idx: any) {
    if (e.target.checked) {
      if (this.previousSelectedValue != undefined) {
        this.reportHeaderTemplateList[this.previousSelectedValue].childCheckBox = false;
      }
      list.childCheckBox = true;
      this.auditTrail.refNo = list.TEMPLATE_ID;
    } else {
      list.childCheckBox = false;
    }
    this.previousSelectedValue = idx;
    this.visibleAuditTrail = this.reportHeaderTemplateList.some((list: any) => list.childCheckBox);
  }

  fieldValidation(elementIds: string[]) {
    elementIds.forEach((elementId) => {
      const element = document.getElementById(elementId) as HTMLInputElement;
      element.style.color = 'red';
    });
  }

  onNgModelChange(items: any, fieldId: string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    field.style.color = items ? '#005c8a' : 'red';
  }

  operationFlag: any;
  popupDataTitle: any = {
    title: ''
  };

  popupTitle: string | null = 'title';
  @ViewChild('addAndEditPopup', { static: true }) addAndEditPopup: TemplateRef<any>;
  @ViewChild('deletePopup', { static: true }) deletePopup: TemplateRef<any>;
  @ViewChild('previewPopup', { static: true }) previewPopup: TemplateRef<any>;
  @ViewChild('notePopup', { static: true }) notePopup: TemplateRef<any>;
  visibleAddAndEditPopup: MatDialogRef<TemplateRef<any>>;
  visibleDeletePopup: MatDialogRef<TemplateRef<any>>;
  visiblePreviewPopup: MatDialogRef<TemplateRef<any>>;
  visibleNotePopup: MatDialogRef<TemplateRef<any>>;

  notePopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  previewPopupConfig = {
    width: '1000px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '100px' },
  };

  addAndEditPopupConfig = {
    width: '100%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  deletePopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  singleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: false,
    allowSearchFilter: true,
    singleSelection: true,
    itemsShowLimit: 1,
    closeDropDownOnSelection: true,
  };

  multipleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: true,
    allowSearchFilter: true,
  };
  selectedRepeatIntervalUnit: any = [];
  selectedRepeatIntervalUnitDisplayExp: any = [];
  selectedRepeatIntervalUnitValueExp: any = [];
  repeatIntervalUnitDropdown: any = [];



  visibleAddButton: boolean;
  visibleEditButton: boolean;
  visibleReasonForUpdateField: boolean;
  openAddPopup() {
    this.visibleAddButton = true;
    this.visibleEditButton = false;
    this.visibleReasonForUpdateField = false;
    this.operationFlag = 'ADD';
    this.popupDataTitle.title = "Create Document Report Headers Template";
    this.reportHeaderTemplateData = {};
    this.reportHeaderTemplateData.templateName = '';
    this.reportHeaderTemplateData.template = '';
    this.reportHeaderTemplateData.isActive1 = true;
    this.reportHeaderTemplateData.isActive = "Y";
    this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
  }

  previousData: any;

  positionValue: any = 1;
  openEditPopup(editRowData: any, editFlag: boolean) {
    this.isProcessing = true;
    this.previousData = editRowData;
    this.visibleReasonForUpdateField = true;
    this.visibleAddButton = false;
    this.visibleEditButton = true;
    this.operationFlag = 'EDIT';
    this.popupDataTitle.title = "Update Report Header Template";

    this.appService.getDocumentReportHeaderTemplateById(editRowData.TEMPLATE_ID).subscribe((response: any) => {
      this.reportHeaderTemplateData = response[0];
      this.reportHeaderTemplateData.isActive1 = this.reportHeaderTemplateData.isActive == "Y";
      this.reportHeaderTemplateData.updateReason = '';
      this.isProcessing = false;
    })
    this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
  }

  refreshGridData() {
    this.getCall();
  }

  addAndEditFunction(add_edit_template: any) {

    const validations = [
      { condition: !add_edit_template.templateName, id: 'template-name' },
      { condition: !add_edit_template.template, id: 'template' },
      { condition: this.operationFlag == 'EDIT' && !add_edit_template.updateReason, id: 'update-reason' }
    ]

    const invalidIds = validations.filter((validation) => validation.condition).map((validation) => validation.id);

    if (invalidIds.length > 0) {
      this.fieldValidation(invalidIds);
    } else {
      this.isProcessing = true;

      const obj = { ...add_edit_template };

      if (this.operationFlag !== 'EDIT') {
        delete obj.updateReason;
      }
      const data = {
        ...obj,
        isActive: obj.isActive1 ? 'Y' : 'N'
      }

      if (this.operationFlag == 'ADD') {
        this.appService.addDocumentReportHeaderTemplate(data).subscribe({
          next: (Response: any) => {
            if (Response.resultType == "S") {
              this.getCall();
              this.visibleAddAndEditPopup.close();
              this.showSnackBar(Response.result, Response.resultType);
            } else {
              this.isProcessing = false;
              this.showSnackBar(Response.result, Response.resultType);
            }
          },
          error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
      } else {

        const modifiedData = {
          ...data,
          templateId: this.reportHeaderTemplateData.templateId
        }
        delete modifiedData.createdOn;
        delete modifiedData.updatedOn;
        this.appService.updateDocumentReportHeaderTemplate(modifiedData).subscribe({
          next: (Response: any) => {
            if (Response.resultType == "S") {
              this.getCall();
              this.visibleAddAndEditPopup.close();
              this.showSnackBar(Response.result, Response.resultType);
            } else {
              this.isProcessing = false;
              this.showSnackBar(Response.result, Response.resultType);
            }
          },
          error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
      }
    }
  }

  cancelAddAndEditFunction() {
    this.visibleAddAndEditPopup.close();
  }

  deleteReportHeaderTemplate: any;
  openDeletePopup(deleteRowData: any) {
    this.operationFlag = 'DELETE';
    this.popupDataTitle.title = "Delete Report Header Template";
    this.deleteReportHeaderTemplate = deleteRowData;
    if (this.reportHeaderTemplateData.deleteReason != undefined) {
      this.reportHeaderTemplateData.deleteReason = '';
    }
    this.visibleDeletePopup = this.dialog.open(this.deletePopup, this.deletePopupConfig);
  }

  deleteFunction(deletingTemplate: any) {
    if (deletingTemplate.deleteReason) {
      this.isProcessing = true;

      const data = {
        templateId: this.deleteReportHeaderTemplate.TEMPLATE_ID,
        templateName: this.deleteReportHeaderTemplate.TEMPLATE_NAME,
        deleteReason: this.reportHeaderTemplateData.deleteReason,
      }

      this.appService.deleteDocumentReportHeaderTemplate(data).subscribe({
        next: (Response: any) => {
          if (Response.resultType == "S") {
            this.getCall();
            this.visibleDeletePopup.close();
            this.showSnackBar(Response.result, Response.resultType);
          } else {
            this.isProcessing = false;
            this.showSnackBar(Response.result, Response.resultType);
          }
        },
        error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      });
    } else {
      const field = document.getElementById('delete-reason-validation') as HTMLInputElement;
      field.style.color = 'red';
    }
  }

  cancelDeleteFunction() {
    this.visibleDeletePopup.close();
  }

  showSnackBar(message: string, type: string) {
    const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel

      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    sb.onAction().subscribe(() => {
      sb.dismiss();
    });
  }

  @ViewChild('angularEditor', { static: true }) angularEditor: TemplateRef<any>;
  visibleAngularEditor: MatDialogRef<TemplateRef<any>>;

  angularEditorConfig = {
    width: '100%',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  editorTitle: string = '';
  editorNgModel: string = '';
  openEditor(title: string, value: string) {
    this.editorTitle = title;
    this.editorNgModel = value;
    this.visibleAngularEditor = this.dialog.open(this.angularEditor, this.angularEditorConfig);
  }

  disabled: EditorConfig = {
    buttons: [],
  };

  enabled: EditorConfig = {
    buttons: ST_BUTTONS,
  };

  cancelAngularEditor() {
    this.visibleAngularEditor.close();
  }

  getClobData(list: any, colunName: any, event: any) {
    event.stopPropagation();
    this.isProcessing = true;
    let docObj = {

      primeIdentifier: list.PRIM_IDENTIFIER,
      tableView: list.tablevwname,
      columnName: colunName
    }
    this.appService.getClobToViewAudit(docObj).subscribe({
      next: (Response: any) => {
        this.previewTemplate(Response.result);
      }, error: (error) => {
        throw new Error(error);
      }

    })
    this.isProcessing = false;

  }

  previewTemplate(value: any) {
    this.previewData = this.sanitizer.bypassSecurityTrustHtml(value);
    this.visiblePreviewPopup = this.dialog.open(this.previewPopup, this.previewPopupConfig);
  }

  cancelPreviewFunction() {
    this.visiblePreviewPopup.close();
  }

  clickToGetNote() {
    this.visibleNotePopup = this.dialog.open(this.notePopup, this.notePopupConfig);
  }

  cancelNote() {
    this.visibleNotePopup.close();
  }

  @ViewChild(DynamicAuditTrailComponent) dynamicAuditTrailComponent!: DynamicAuditTrailComponent;

  openAuditTrail(viewType: any, notification: any) {
    this.auditTrail.refNo = viewType == 'overAll' ? null : notification.TEMPLATE_ID;
    this.auditTrail.gridName = 'DOCUMENT_REPORT_HEADER_TEMPLATE';
    this.auditTrail.report_And_Popup_Name = 'Document Report Header Template Audit Trail';
    this.dynamicAuditTrailComponent.triggerTrail(notification);
  }


  openReport(reportType: string) {
    this.excelPdf.reportObj = this.reportObj;
    this.excelPdf.reportType = 'Dynamic';
    this.excelPdf.reportName = 'Document Report Header Template Report';
    this.excelPdf.dropDown = this.columnLists?.fieldColumnarray?.map((item: any) => item.fieldColumnarray);
    this.excelPdfComponent.openReportPopup(reportType);
  }

  columnSearch(column: string, event: Event, dataTYpe: any): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems = this.reportHeaderTemplateList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.reportHeaderTemplateList.filter((item: any) => {
        const columnValue = item[column];
        if (dataTYpe === 'd') {
          if (columnValue == null) {
            return false;
          }
          const formattedDate = this.datePipe.transform(columnValue, 'dd-MMM-yyyy');
          return formattedDate?.toString().toLowerCase().includes(filter) ?? false;
        } else if (typeof columnValue === 'string') {
          return columnValue.toLowerCase().includes(filter);
        } else if (typeof columnValue === 'number') {
          // Convert number to string before checking for inclusion
          return columnValue.toString().toLowerCase().includes(filter);
        } else if (columnValue instanceof Date) {
          // Format date to string before checking for inclusion
          const formattedDate = columnValue.toISOString().substring(0, 10);
          return formattedDate.toLowerCase().includes(filter);
        }
        // If it's not a string, return false to exclude it from filtering
        return false;
      });
    }
  }

  @ViewChild(GridReorderComponent) gridReorderComponent!: GridReorderComponent;
  openReorder() {
    this.gridReorderComponent.reordercall(this.reportObj.gridName, this.reportObj.tableOrViewName, null, 0)
  }

  onChildValueEmitted() {
    this.getCall();
  };
}
